module.exports = __webpack_public_path__ + "img/c4.2ec8ee16.png";